/**
 * Treatment-calendar visual: rows of small squares grouped into 5-day weeks.
 * Filled squares = treatment days.
 * SAINT®: 1 week, all 5 weekdays filled.
 * NeuroStar: weeks 1–6 all 5 days filled, plus 2 taper weeks with Mon/Wed/Fri filled.
 */
const weekdays = ["M", "T", "W", "T", "F"];

// SAINT: 1 week, all 5 days filled
const saintWeeks = [[true, true, true, true, true]];

// NeuroStar: 6 full weeks + 2 taper weeks (Mon/Wed/Fri only)
const neurostarWeeks = [
  [true, true, true, true, true],
  [true, true, true, true, true],
  [true, true, true, true, true],
  [true, true, true, true, true],
  [true, true, true, true, true],
  [true, true, true, true, true],
  [true, false, true, false, true],
  [true, false, true, false, true],
];

const CalendarRow = ({
  label,
  weeks,
  filledClass,
  emptyClass,
}: {
  label: string;
  weeks: boolean[][];
  filledClass: string;
  emptyClass: string;
}) => (
  <div className="flex items-start gap-3">
    <span className="w-16 shrink-0 pt-0.5 text-xs font-bold text-primary">
      {label}
    </span>
    <div className="flex flex-wrap gap-2">
      {weeks.map((week, wi) => (
        <div
          key={wi}
          className="flex flex-col items-center gap-1 rounded-lg border border-border bg-background p-1.5"
        >
          <div className="flex gap-0.5">
            {week.map((filled, di) => (
              <div
                key={di}
                className={`h-5 w-5 rounded-sm ${
                  filled ? filledClass : emptyClass
                }`}
                title={filled ? weekdays[di] : ""}
              />
            ))}
          </div>
          <span className="text-[0.6rem] text-muted-foreground">
            {wi < 6 ? `Wk ${wi + 1}` : "Taper"}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export const TreatmentCalendar = () => (
  <div className="space-y-4 rounded-xl border border-border bg-card p-4">
    <CalendarRow
      label="SAINT®"
      weeks={saintWeeks}
      filledClass="bg-accent"
      emptyClass="bg-muted"
    />
    <div className="border-t border-border" />
    <CalendarRow
      label="NeuroStar®"
      weeks={neurostarWeeks}
      filledClass="bg-primary"
      emptyClass="bg-muted"
    />
    <p className="pt-1 text-xs text-muted-foreground">
      Each square is one weekday. Filled squares are days you come in for
      treatment.
    </p>
  </div>
);
